//! This file is automatically generated by 'scripts/locales/generateI18nTypes.ts'
//! It should not be manually modified.

export const i18nNamespaces = [
  "accountSelection",
  "advancedSearch",
  "clipDetails",
  "clipTable",
  "collectionDetails",
  "common",
  "dashboard",
  "facetingPanel",
  "home",
  "login",
  "operations",
  "productionSelection",
  "table",
  "workflowTable"
]
